module.exports = __webpack_public_path__ + "img/family_account_management.f6653514.svg";